//icon, campaign name, field, old_value, new_value
export const columnsDataComplex = [
  {
    Header: "APP",
    accessor: "appIcon",
  },
  {
    Header: "CAMPAIGN",
    accessor: "campaignName",
  },
  {
    Header: "PARTNER",
    accessor: "partnerName",
  },
  {
    Header: "FIELD",
    accessor: "field",
  },
  {
    Header: "BEFORE",
    accessor: "oldValue",
  },
  {
    Header: "AFTER",
    accessor: "newValue",
  },
  {
    Header: "DATE",
    accessor: "createdAt",
  },
];
